import {useEffect, useState} from "react";
import trainingCategoryApi from "../../api/trainingCategory/trainingCategory";
import trainingTypeApi from "../../api/trainingType/trainingType";
import {ui} from "../../helpers/ui";

const InitTrainingCategoriesLogic = () => {
  const [categories, setCategories] = useState<any[]>([]);
  const [categoryForm, setCategoryForm] = useState({name: ""});
  const [editingCategoryId, setEditingCategoryId] = useState<number | null>(
    null
  );

  const [typeForm, setTypeForm] = useState({
    name: "",
    price: 0,
    quantity: 1,
    durationWeeks: "",
    durationMonths: "",
    trainingCategoryId: 0,
  });
  const [editingTypeId, setEditingTypeId] = useState<number | null>(null);

  const loadCategories = () => {
    trainingCategoryApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setCategories(response.data);
        }
      })
      .catch((e) =>
        ui.alert(e.response?.data?.error?.message || "Greška")
      );
  };

  useEffect(() => {
    loadCategories();
  }, []);

  const onCategoryChange = (event: any) => {
    setCategoryForm({...categoryForm, [event.target.name]: event.target.value});
  };

  const onCategorySave = () => {
    if (!categoryForm.name) {
      ui.alert("Naziv je obavezan");
      return;
    }
    if (editingCategoryId) {
      trainingCategoryApi
        .update(editingCategoryId, categoryForm)
        .then(() => {
          resetCategoryForm();
          loadCategories();
        })
        .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
    } else {
      trainingCategoryApi
        .create(categoryForm)
        .then(() => {
          resetCategoryForm();
          loadCategories();
        })
        .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
    }
  };

  const onCategoryEdit = (category: any) => {
    setEditingCategoryId(category.id);
    setCategoryForm({name: category.name});
  };

  const onCategoryDelete = async (id: number) => {
    const confirmed = await ui.confirm("Sigurno želite da obrišete kategoriju?");
    if (!confirmed) return;
    trainingCategoryApi
      .remove(id)
      .then(() => loadCategories())
      .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
  };

  const resetCategoryForm = () => {
    setEditingCategoryId(null);
    setCategoryForm({name: ""});
  };

  const onTypeChange = (event: any) => {
    setTypeForm({...typeForm, [event.target.name]: event.target.value});
  };

  const onTypeSave = () => {
    if (!typeForm.name || !typeForm.trainingCategoryId) {
      ui.alert("Naziv i kategorija su obavezni");
      return;
    }
    const data: any = {
      name: typeForm.name,
      price: +typeForm.price,
      quantity: +typeForm.quantity,
      trainingCategoryId: +typeForm.trainingCategoryId,
    };
    if (typeForm.durationWeeks) data.durationWeeks = +typeForm.durationWeeks;
    if (typeForm.durationMonths) data.durationMonths = +typeForm.durationMonths;

    if (editingTypeId) {
      trainingTypeApi
        .update(editingTypeId, data)
        .then(() => {
          resetTypeForm();
          loadCategories();
        })
        .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
    } else {
      trainingTypeApi
        .create(data)
        .then(() => {
          resetTypeForm();
          loadCategories();
        })
        .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
    }
  };

  const onTypeEdit = (type: any) => {
    setEditingTypeId(type.id);
    setTypeForm({
      name: type.name,
      price: type.price,
      quantity: type.quantity,
      durationWeeks: type.durationWeeks || "",
      durationMonths: type.durationMonths || "",
      trainingCategoryId: type.trainingCategoryId,
    });
  };

  const onTypeDelete = async (id: number) => {
    const confirmed = await ui.confirm("Sigurno želite da obrišete tip treninga?");
    if (!confirmed) return;
    trainingTypeApi
      .remove(id)
      .then(() => loadCategories())
      .catch((e) => ui.alert(e.response?.data?.error?.message || "Greška"));
  };

  const resetTypeForm = () => {
    setEditingTypeId(null);
    setTypeForm({
      name: "",
      price: 0,
      quantity: 1,
      durationWeeks: "",
      durationMonths: "",
      trainingCategoryId: 0,
    });
  };

  return {
    categories,
    categoryForm,
    editingCategoryId,
    onCategoryChange,
    onCategorySave,
    onCategoryEdit,
    onCategoryDelete,
    resetCategoryForm,
    typeForm,
    editingTypeId,
    onTypeChange,
    onTypeSave,
    onTypeEdit,
    onTypeDelete,
    resetTypeForm,
  };
};

export default InitTrainingCategoriesLogic;
